module.exports = __webpack_public_path__ + "img/general-exam.ae65c970.png";